/**
 * Tab modules
 */
export * from './tab';
